export default {
  en: {
    id: 'exercise4',
    subtitle: 'SUGGESTED STRUCTURE <br> PCI ENERGY SERVICES GROUP',
    blocks: [
      {
        task: `Siemens expects PCI to have IS for three new Westinghouse plant additions to SWPC’s Network converted and running immediately before rollout of the newly merged company. `,
        title: "S = ",
        prop: 's',
        answer: ' ',
        note: 'Sit, DE R1',
        disableEdit: true
      },
      {
        task: `PCI also has four other major IS data conversion projects to complete for SWPC in the same period, which Siemens wants without duplication or delay.  Creates risk that IS data conversion will not be in place in time for Westinghouse transfers`,
        title: "C = ",
        prop: 'c',
        answer: ' ',
        note: 'Sol, R2',
        disableEdit: true
      },
      {
        task: 'How eliminate the risk?',
        title: "Q = ",
        prop: 'q',
        answer: ' ',
        disableEdit: true
      }
    ],
    image: '5d6-3.png',
    withoutAnswers: true,
    hideTaskTitle: true,
    submitButton: 'switch'
  },
}



// WEBPACK FOOTER //
// ./client/app/modules/courses/5/5d/writingProposalsPlans/i18n/exercise4.js